import { Feature, FeatureCollection } from 'geojson'
import { useEffect, useMemo, useState } from 'react'

const emptyOverlaps: Feature[] = []

export const useEditorOverlaps = (features: FeatureCollection, testShapes?: Feature[]) => {
  const [isReady, setIsReady] = useState(false)

  const worker: Worker = useMemo(
    () => new Worker(new URL('./findEditorOverlapsWorker.ts', import.meta.url), { type: 'module' }),
    []
  )

  const [overlaps, setOverlaps] = useState<Feature[]>()

  useEffect(() => {
    if (!features?.features.length) {
      setOverlaps(emptyOverlaps)
    } else if (testShapes?.length && window.Worker) {
      setIsReady(false)
      worker.postMessage({ featureCollection: features, testShapes })
    }
  }, [features, testShapes, worker])

  useEffect(() => {
    if (window.Worker) {
      worker.onmessage = ({ data }: MessageEvent<Feature[]>) => {
        setOverlaps(data)
        setIsReady(true)
      }
    }
  }, [worker, setIsReady, setOverlaps])

  return {
    isReady,
    overlaps,
  }
}
